module.exports = __webpack_public_path__ + "static/media/bottomBG.5cef4d27.jpg";